export default __webpack_public_path__ + "static/media/awar15.e65da6e1.jpg";